import React from "react";
import PropTypes from "prop-types";

import { percentageLabel } from "./DonutPercentage.module.scss";

const DonutPercentage = ({ percentage }) => (
  <text
    y={50}
    textAnchor="middle"
    dominantBaseline="middle"
    className={percentageLabel}
  >
    <tspan x={50} fontSize={18}>{`${percentage.toFixed(1)}%`}</tspan>
  </text>
);

DonutPercentage.propTypes = {
  percentage: PropTypes.number.isRequired
};

export default DonutPercentage;
